export const cleanFirebaseError = (err) => {
    console.error('[Firebase Error Raw]:', err);
  
    if (!err?.message) return 'Something went wrong';
  
    // Extract the readable part from the Firebase error message
    const raw = err.message;
  
    // Example: "Firebase: Error (auth/email-already-in-use)." → "auth/email-already-in-use"
    const match = raw.match(/\(auth\/(.+?)\)/i);
    if (match) {
      const code = match[1].replace(/-/g, ' ');
      return `Email ${code}`; // You can customize this
    }
  
    return raw.replace(/firebase:/i, '').split('(')[0].trim();
  };
  